var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"SECFilings"}},[(_vm.data)?_c('div',[_c('h1',{attrs:{"align":"center"}},[_vm._v("SEC Filings")]),_c('a',{attrs:{"href":_vm.data.sec_link}},[_vm._v("SEC Edgar")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }